import { useNavigate } from "react-router-dom";
import { useToast } from "duck";
import { useCreateOrganizationMutation } from "requests";
import { FormValues } from "./types";

export const useCreateOrganization = () => {
  const [create] = useCreateOrganizationMutation({ ignoreResults: true });
  const toast = useToast({ status: "success" });
  const navigate = useNavigate();

  return (formValues: FormValues) =>
    create({
      variables: {
        input: {
          ...formValues
        }
      }
    }).then(() => {
      toast({ description: "Organization is created successfully." });
      navigate("/organization-management");
    });
};
